var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreinfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.637,
    height: 28.297,
    viewBox: "0 0 22.637 28.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16642",
    "data-name": "Group 16642",
    transform: "translate(10691.223 5996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5062",
    "data-name": "Rectangle 5062",
    transform: "translate(-10691.223 -5996)",
    fill: "none",
    stroke: "#2279fe",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.638,
    height: 28.297,
    rx: 2.6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 21.238,
    height: 26.897,
    rx: 1.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38129",
    "data-name": "Path 38129",
    d: "M17.8,13.035H7.073a1.019,1.019,0,1,1,0-2.035H17.8a1.019,1.019,0,1,1,0,2.035Z",
    transform: "translate(-10692.351 -5993.772)",
    fill: "#2279fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38130",
    "data-name": "Path 38130",
    d: "M17.8,8.035H7.073A1.019,1.019,0,1,1,7.073,6H17.8a1.019,1.019,0,1,1,0,2.035Z",
    transform: "translate(-10691.94 -5993.859)",
    fill: "#2279fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5061",
    "data-name": "Rectangle 5061",
    transform: "translate(-10686.351 -5977.89)",
    fill: "#2279fe",
    stroke: "#2279fe",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.923,
    height: 2.264,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6.923,
    height: 1.264,
    rx: 0.5,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreinfo);
export default __webpack_public_path__ + "static/media/More info.ebc8984a.svg";
export { ForwardRef as ReactComponent };